import { useEffect, useRef, useState } from 'react';

// collapse just this mask (keeps its head + this button)
export default function MaskToggle({ t, id }) {
  const [c, setC] = useState(false);
  const ref = useRef(null);
  useEffect(() => { ref.current?.closest('.mask')?.classList.toggle('mask-collapsed', c); }, [c]);
  return (
    <button ref={ref} type="button" className="mask-toggle" data-testid={`mask-toggle-${id}`} aria-pressed={c} onClick={(e) => { e.stopPropagation(); setC((v) => !v); }}>
      {c ? `▲ ${t.maskShow}` : `▼ ${t.maskHide}`}
    </button>
  );
}
